export default __webpack_public_path__ + "static/media/trash-bin-filled-bold.3288e0ee.svg";